import React from "react";
import playlistimg from "../assets/img/playlistimg.png";
import { useHistory } from "react-router";
import Card from "../components/card/Card.jsx";
import PlaylistCard from "../components/card/PlaylistCard";
import Footer from "../components/footer/Footer";

export default function Playlist() {
  const history = useHistory();
  const newlyAdded = [
    { type: "bid", image: playlistimg },
    { type: "bid", image: playlistimg },
    { type: "direct", image: playlistimg },
    { type: "bid", image: playlistimg },
    { type: "bid", image: playlistimg },
    { type: "direct", image: playlistimg },
    { type: "bid", image: playlistimg },
    { type: "bid", image: playlistimg },
    { type: "direct", image: playlistimg },
  ];
  return (
    <div className="playlist-wrapper">
      <div
        className="price"
        style={{
          marginTop: "-14px",
          fontSize: "12px",
          fontFamily: "sans-serif",
        }}
      >
        <div>
          <div style={{ marginBottom: "4px" }}> 1 Music = $USD 0.452</div>
          <div> 1 BNB = $USD 0.452 </div>
        </div>
      </div>

      <div className="playlist-header">
        <div>PLAYLIST</div>
        <div>
          <select>
            <option value="recently">Recently</option>
            <option value="recently">Old</option>
          </select>
        </div>
      </div>
      <div className="first-row-wrapper">
        <div className="first-row">
          {newlyAdded.map((item, i) => {
            return (
              <div
                key={i}
                className="each-card"
                onClick={() =>
                  history.push({
                    pathname: "/playmusic",
                    state: { type: item.type },
                  })
                }
              >
                <PlaylistCard image={item.image} type={item.type} />
              </div>
            );
          })}
        </div>
      </div>
      <div className="first-row-wrapper">
        <div className="first-row">
          {newlyAdded.map((item, i) => {
            return (
              <div
                key={i}
                className="each-card"
                onClick={() =>
                  history.push({
                    pathname: "/nftdetails",
                    state: { type: item.type },
                  })
                }
              >
                <PlaylistCard image={item.image} type={item.type} />
              </div>
            );
          })}
        </div>
      </div>
      <div className="first-row-wrapper">
        <div className="first-row">
          {newlyAdded.map((item, i) => {
            return (
              <div
                key={i}
                className="each-card"
                onClick={() =>
                  history.push({
                    pathname: "/nftdetails",
                    state: { type: item.type },
                  })
                }
              >
                <PlaylistCard image={item.image} type={item.type} />
              </div>
            );
          })}
        </div>
      </div>
      <div className="first-row-wrapper">
        <div className="first-row">
          {newlyAdded.map((item, i) => {
            return (
              <div
                key={i}
                className="each-card"
                onClick={() =>
                  history.push({
                    pathname: "/nftdetails",
                    state: { type: item.type },
                  })
                }
              >
                <PlaylistCard image={item.image} type={item.type} />
              </div>
            );
          })}
        </div>
      </div>
      <Footer />
    </div>
  );
}
